import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { createContext, useContext } from 'react';

export const FormContext = createContext<Form | undefined>(undefined);

export function useForm() {
  const context = useContext(FormContext);
  if (context === undefined) {
    throw new Error('useForm must be used within a FormProvider');
  }
  return context;
}

export function useNestedFormByTarget(target: string) {
  const form = useForm();

  if (!form.nestedForms?.length) {
    return;
  }

  return form.nestedForms?.find((nestedForm) =>
    nestedForm.targets?.includes(target),
  )?.form;
}
